/**
 * @name Main
 * @description Main Layout (Contenedor principal con Topbar y Sidebar)
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// React Router
import { Redirect } from 'react-router-dom';

import { Topbar } from '@components';
import { AuthService } from '@services';
import { Layout } from '@styles';

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminActions: [],
      sidebarActions: []
    };
  }

  render() {
    const { children } = this.props;
    const hasActiveSession = AuthService.hasActiveSession();

    return (
      <>
        {hasActiveSession ? (
          <Layout.MainWrapper>
            <Topbar
              showBackButton={this.props.backButton}
              backRoute={this.props.backRoute}
              showSidebar={this.props.sidebar}
              adminActions={this.state.adminActions}
              sidebarActions={this.state.sidebarActions}
              {...children.props}
            />
            <Layout.ContentWrapper>
              {children}
            </Layout.ContentWrapper>
          </Layout.MainWrapper>
        ) : (
          <Redirect to="/login" />
        )}
      </>
    );
  }
}

Main.propTypes = {
  children: PropTypes.node,
  backButton: PropTypes.bool,
  backRoute: PropTypes.string,
  sidebar: PropTypes.bool,
};

export default Main;
